import { render, staticRenderFns } from "./compeModelTitle.vue?vue&type=template&id=d5320bce&scoped=true&"
import script from "./compeModelTitle.vue?vue&type=script&lang=ts&"
export * from "./compeModelTitle.vue?vue&type=script&lang=ts&"
import style0 from "./compeModelTitle.vue?vue&type=style&index=0&id=d5320bce&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d5320bce",
  null
  
)

export default component.exports